export default function () {
  // The Desk filter is auto-injected before the org filter by FilterCard.
  return [
    {
      key: 'orgIds',
      type: 'org',
      props: {
        clearable: true,
        multiple: true,
      },
      collapsed: true,
      collapsedMinWidth: '450px',
    },
    {
      key: 'buIds',
      label: 'businessUnit',
      type: 'bu',
      props: {
        clearable: true,
        multiple: true,
      },
      collapsed: true,
      collapsedMinWidth: '450px',
    },
  ];
}
